import { useContext } from 'react';
import HeaderContext from '@app/shell/state';

/**
 * Isomorphic hook that exposes the data used by Header to handle click tracking.
 */
const useHeader = () => useContext(HeaderContext);

export default useHeader;
